import React from 'react';
import { Line } from '@ant-design/charts';
import { Card, Empty, Spin } from 'antd';

interface LineChartProps {
  title?: string;
  data: Array<{ date: string; value: number; category?: string }>;
  loading?: boolean;
  height?: number;
  xField?: string;
  yField?: string;
  seriesField?: string;
  smooth?: boolean;
  yAxis?: {
    title?: string;
    formatter?: (value: number) => string;
  };
  xAxis?: {
    title?: string;
  };
  tooltip?: {
    formatter?: (datum: any) => { name: string; value: string };
  };
  color?: string | string[];
  annotations?: any[];
}

export const LineChart: React.FC<LineChartProps> = ({
  title,
  data,
  loading = false,
  height = 300,
  xField = 'date',
  yField = 'value',
  seriesField,
  smooth = true,
  yAxis,
  xAxis,
  tooltip,
  color,
  annotations,
}) => {
  if (loading) {
    return (
      <Card title={title}>
        <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Card title={title}>
        <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Empty description="No data available" />
        </div>
      </Card>
    );
  }

  const config = {
    data,
    xField,
    yField,
    seriesField,
    smooth,
    height,
    color,
    annotations,
    xAxis: {
      title: xAxis?.title,
      tickCount: 5,
    },
    yAxis: {
      title: yAxis?.title,
      label: yAxis?.formatter
        ? {
            formatter: yAxis.formatter,
          }
        : undefined,
    },
    tooltip: tooltip?.formatter
      ? {
          formatter: tooltip.formatter,
        }
      : undefined,
    legend: seriesField ? { position: 'top' } : false,
    point: {
      size: 4,
      shape: 'circle',
      style: {
        fill: '#fff',
        stroke: '#5B8FF9',
        lineWidth: 2,
      },
    },
    area: seriesField ? undefined : {
      style: {
        fillOpacity: 0.15,
      },
    },
  };

  return (
    <Card title={title}>
      <Line {...config} />
    </Card>
  );
};

export default LineChart;
